import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchAppConfig } from "../../redux/action/appConfig";

/**
 * Dispatches fetchAppConfig on mount. The thunk skips the API call
 * if footerLinks are already in the store (e.g. after navigation).
 */
export default function AppConfigLoader() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAppConfig());
  }, [dispatch]);

  return null;
}
